<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer" @click.prevent="toogleView">
    <v-layout row wrap>
      <v-flex xs12 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap body-1>
                <v-flex xs6 py-0 v-if="admin">
                  {{humanWireDate}} {{humanWireTime}} - <span class="color-logo-green font-weight-bold uppercase">{{companyName}}</span> <span class="caption">{{companyDocument}}</span> ({{l(record.value, record.currency)}})
                </v-flex>
                <v-flex xs6 py-0 v-if="!admin">
                  <v-layout row wrap caption>
                    <v-flex xs12 py-0>
                      <span class="font-weight-bold body-2 color-dark-blue">{{humanWireDate}}</span> {{humanWireTime}} - <span class="font-weight-bold body-2 color-logo-green uppercase">{{receiver.social_name}}</span> <span class="font-weight-bold body-2">({{l(record.value, record.currency)}})</span>
                    </v-flex>
                    <v-flex xs6 py-0>
                      <div @click.stop="" class="uppercase nowrap">ID {{record.id}}</div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-0 text-xs-right>
                  <v-layout row wrap caption>
                    <v-flex xs12 py-0 style="position: relative">
                      {{longAccountName(record.to_bank_account)}}
                      <div v-if="admin" class="top icons_wrapper">
                        <ion-icon v-if="pixRegistrationStatus == 'error'" name="alert-circle-outline" class="fail icon" width="30" height="30" title="Erro ao registrar Pix" ></ion-icon>
                        <ion-icon v-if="pixRegistrationStatus == 'done'" name="checkmark-circle-outline" class="success icon" width="30" height="30" title="Pix registrado" ></ion-icon>
                        <ion-icon v-if="hasPixConfirmationFailed" name="alert-circle-outline" class="fail icon" width="30" height="30" :title="pixConfirmationError"></ion-icon>
                        <ion-icon v-if="pixConfirmationStatus == 'done'" name="checkmark-circle-outline" class="success icon" width="30" height="30" title="Pix processado" ></ion-icon>

                        <ion-icon v-if="(genialPixStep == 'checking_pix_key' && genialPixStatus == 'failed')" name="alert-circle-outline" class="fail icon" width="30" height="30" title="Erro ao consultar chave Pix" ></ion-icon>
                        <ion-icon v-if="(genialPixStep == 'checking_pix_key' && genialPixStatus == 'waiting')" name="alert-circle-outline" class="waiting icon" width="30" height="30" title="Aguardando consultar chave Pix" ></ion-icon>
                        <ion-icon v-if="(genialPixStep == 'checking_pix_key' && genialPixStatus == 'processing')" name="alert-circle-outline" class="processing icon" width="30" height="30" title="Consultando chave Pix" ></ion-icon>
                        <ion-icon v-if="(genialPixStep == 'sending_pix' && genialPixStatus == 'failed')" name="alert-circle-outline" class="fail icon" width="30" height="30" title="Erro ao enviar Pix" ></ion-icon>
                        <ion-icon v-if="(genialPixStep == 'sending_pix' && genialPixStatus == 'waiting')" name="alert-circle-outline" class="waiting icon" width="30" height="30" title="Aguardando envio do Pix" ></ion-icon>
                        <ion-icon v-if="(genialPixStep == 'sending_pix' && genialPixStatus == 'processing')" name="alert-circle-outline" class="processing icon" width="30" height="30" title="Enviando Pix" ></ion-icon>
                        <ion-icon v-if="(genialPixStep == 'checking_pix' && genialPixStatus == 'failed')" name="alert-circle-outline" class="fail icon" width="30" height="30" title="Não foi possível confirmar o Pix" ></ion-icon>
                        <ion-icon v-if="(genialPixStep == 'checking_pix' && genialPixStatus == 'waiting')" name="alert-circle-outline" class="waiting icon" width="30" height="30" title="Aguardando confirmação do Pix" ></ion-icon>
                        <ion-icon v-if="(genialPixStep == 'checking_pix' && genialPixStatus == 'processing')" name="alert-circle-outline" class="processing icon" width="30" height="30" title="Verificando confirmação do Pix" ></ion-icon>
                        <ion-icon v-if="(genialPixStep == 'done' && genialPixStatus == 'failed')" name="alert-circle-outline" class="fail icon" width="30" height="30" title="Pix falhou" ></ion-icon>
                        <ion-icon v-if="(genialPixStep == 'done' && genialPixStatus == 'processing')" name="alert-circle-outline" class="processing icon" width="30" height="30" title="Pix enviado" ></ion-icon>
                        <span class="wire_status">{{wireStatus}}</span>
                      </div>
                      <div v-if="admin && showActionButtons" class="bottom icons_wrapper">
                        <span class="nowrap wire_status rounded-chip small" @click.prevent.stop="updateBankAccount">Atualizar e refazer</span>
                        <span v-if="isRetryCompanyWireAllowed" class="nowrap wire_status rounded-chip small" @click.prevent.stop="retryCompanyWire">Refazer</span>
                        <span v-if="isMarkAsSuccessAllowed" class="nowrap wire_status rounded-chip small" @click.prevent.stop="markAsSuccess">Marcar como sucesso</span>
                      </div>
                    </v-flex>
                    <v-flex xs12 py-0 v-if="admin">
                      {{longAccountName(record.to_bank_account.intermediary_bank_account)}}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 py-0 mt-3 v-if="current_view === 'detailed'">
                  <v-layout row wrap caption>
                    <v-flex xs6>
                      <div v-if="transactionsLoaded == 'not_loaded'">{{i18n('Carregando transações...')}}</div>
                      <div v-if="transactionsLoaded == 'error'">{{i18n('Algo errado. Não foi possível carregar as transações.')}}</div>
                      <div v-if="transactionsLoaded == 'not_authorized'">{{i18n('Não foi possível carregar as transações. Você não foi autorizado.')}}</div>
                      <div v-if="transactionsLoaded == 'empty'">{{i18n('Não existem transações associadas.')}}</div>
                      <span v-if="transactionsLoaded == 'ok'" class="nowrap subtitle rounded-chip">{{i18n('Transações associadas')}}: {{record.bank_transactions.length}}</span>
                      <span v-if="transactionsLoaded == 'ok'" class="nowrap subtitle rounded-chip" @click.prevent.stop="openInNewWindow(`#/receipt/${record.bank_transactions[0].wire_id}`)">
                        {{i18n('Recibo')}}
                      </span>
                    </v-flex>
                    <v-flex xs3 @click.prevent.stop="">
                      <v-btn xs3 @click.prevent.stop="" @click="exportTransactionCsvForBank" block dark class="ma-0 btn-style--secondary small mt-3" v-if="admin">
                        <v-icon left>paid</v-icon>
                        CSV Banco
                      </v-btn>
                      <v-btn block dark class="ma-0 btn-style--secondary small mt-3" v-if="admin && record.facilita_bank === true && record.status === 'success'"
                            @click.prevent.stop="openChargebackDialog(record)">
                        <v-icon left>money</v-icon>
                        Abrir Chargeback
                      </v-btn>
                    </v-flex>
                    <v-flex xs3 @click.prevent.stop="">
                      <v-btn xs3 @click.prevent.stop="" @click="exportTransactionCsvForCustomer" block dark class="ma-0 btn-style--secondary small mt-3" v-if="admin">
                        <v-icon left>person</v-icon>
                        CSV Cliente
                      </v-btn>
                      <v-btn @click="exportTransactionCsvForCustomer" block dark class="ma-0 btn-style--secondary small mt-3" v-if="!admin">
                        CSV
                      </v-btn>
                      <v-btn block dark class="ma-0 btn-style--secondary small mt-3" v-if="admin && record.facilita_bank === true && record.status === 'success'"
                            @click.prevent.stop="openInfractionDialog">
                        <v-icon left>info</v-icon>
                        Abrir Infração
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 pt-3>
                      <transition-group name="fade">
                        <transaction :selectionDisabled="true" :record="transaction" v-for="transaction in record.bank_transactions" :key="transaction.id" cursor-default />
                      </transition-group>
                      <div v-if="record.status !== 'success' && record.company_wire_attempts" class="error-description">
                        <div><span>Integração: </span> {{record.company_wire_attempts[0].payment_integration}}</div>
                        <div><span>Código do Erro: </span> {{record.company_wire_attempts[0].error_code}}</div>
                        <div><span>Descrição do Erro: </span>{{record.company_wire_attempts[0].error_description}}</div>
                        <div><span>Erro Bruto: </span>{{record.company_wire_attempts[0].error_raw}}</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
    <v-dialog v-model="showInfractionDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline">Abrir Infração</v-card-title>
        <v-card-text>
          <v-form ref="infractionForm" lazy-validation>
            <v-textarea
              v-model="infractionForm.description"
              label="Descrição (Obrigatório)"
              required
              :counter="2000"
              maxlength="2000"
            ></v-textarea>

            <v-text-field
              v-model="infractionForm.company_wire_id"
              label="ID da transferência"
              disabled
              readonly
            ></v-text-field>

            <v-text-field
              v-model="infractionForm.type"
              label="Tipo"
              disabled
            ></v-text-field>

            <v-select
              v-model="infractionForm.method"
              :items="infractionMethodOptions"
              item-text="text"
              item-value="value"
              label="Método (Obrigatório)"
              required
            />
          </v-form>
          <div v-if="infractionViewError" class="error--text px-4 pb-2">
            {{ infractionViewError }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="showInfractionDialog = false">Fechar</v-btn>
          <v-btn color="#27DABC" text @click="submitInfraction">Criar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="chargebackDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Solicitar Chargeback</v-card-title>
        <v-card-text>
          <v-form ref="chargebackFormRef" lazy-validation>
            <v-textarea
              label="Descrição (Obrigatório)"
              v-model="chargebackForm.description"
              :rules="[v => !!v || 'Descrição é obrigatória']"
              required
              :counter="2000"
              maxlength="2000"
            />

            <v-currency-field
            label="Valor a ser estornado (Obrigatório)"
            v-model="chargebackForm.amount"
            decimal=","
            thousands="."
            type="text"
            :rules="[v => !!v || 'Valor é obrigatório']"
            required
            ></v-currency-field>

            <v-text-field
              label="Motivo"
              v-model="chargebackForm.reason"
              disabled
              readonly
            />
          </v-form>
          <div v-if="chargebackFormError" class="error--text text-caption mt-2">
            {{ chargebackFormError }}
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="secondary" text @click="chargebackDialog = false">Fechar</v-btn>
          <v-btn color="#27DABC" text @click="submitChargeback">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import utils from "./shared/Utils"
import TransactionWithScheduleItem from "./TransactionWithScheduleItem"

export default {
  name: 'WireItem',
  components: { 'transaction': TransactionWithScheduleItem },
  props: {
    record: {
      type: Object
    },
    admin: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      current_view: 'short',
      transactionsLoaded: 'not_loaded',
      company_wire_actions_disabled: false,
      showInfractionDialog: false,
      infractionViewError: '',
      infractionForm: {
        description: '',
        company_wire_id: '',
        type: '',
        method: null
      },
      infractionMethodOptions: [
        { text: 'Golpe', value: 'scam' },
        { text: 'Não autorizado', value: 'unauthorized' },
        { text: 'Coerção', value: 'coercion' },
        { text: 'Invasão', value: 'invasion' },
        { text: 'Outro', value: 'other' }
      ],
      infractionErrorMessage: '',
      chargebackDialog: false,
      chargebackForm: {
        description: '',
        amount: '',
        reason: 'Chargeback solicitado via painel'
      },
      chargebackFormError: ''
    }
  },
  computed: {
    receiver() {
      return this.record.to_bank_account.company
    },
    companyName() {
      return this.receiver && this.receiver.social_name || 'N/A'
    },
    pixRegistrationStatus() {
      if (this.getLastPix) {
        return this.getLastPix.status
      } else {
        return 'none'
      }
    },
    pixConfirmationError() {
      if (this.getLastPix) {
        return this.getLastPix.confirmation_error || ''
      } else {
        return ''
      }
    },
    pixConfirmationStatus() {
      if (this.getLastPix) {
        return this.getLastPix.confirmation_status || 'none'
      } else {
        return 'none'
      }
    },
    showActionButtons() {
      if(!!this.record.status && this.record.status == 'waiting_correction') {
        return true
      }

      if(!!this.record.status && this.record.status == 'failed') {
        if(this.record.unretryable !== null){
          return !this.record.unretryable
        }

        return true
      }

      if(this.company_wire_actions_disabled) {
        return true
      }

      return false
    },
    isRetryCompanyWireAllowed() {
      if (this.record.status == 'failed' && this.record.ownership_verification_failed) {
        return false
      }
      return true
    },
    isMarkAsSuccessAllowed() {
      if (this.record.status == 'failed' && this.record.ownership_verification_failed) {
        return false
      }
      return true
    },
    hasPixConfirmationFailed() {
      return ['waiting_correction', 'waiting_retry', 'failed'].includes(this.pixConfirmationStatus)
    },
    wireStatus() {
      if (this.record.status == 'success' && (this.pixConfirmationStatus == 'done' || (this.genialPixStatus == 'succeed' && this.genialPixStep == 'done'))) {
        return 'Sucesso'
      }
      if (this.record.status == 'success' && (this.getLastPix || this.getLastGenialPix)) {
        return 'Manualmente confirmada'
      }
      if (this.record.status == 'waiting_confirmation') {
        return 'Aguardando confirmação'
      }
      if (this.record.status == 'waiting_correction') {
        return 'Aguardando correção'
      }
      if (this.record.status == 'waiting_retry') {
        return 'Aguardando nova tentativa'
      }
      if (this.record.status == 'failed' && this.record.ownership_verification_failed) {
        return 'Verificação de Beneficiário Falhou'
      }
      if (this.record.status == 'failed') {
        return 'Falhou'
      }
      if ((!this.record.status || this.record.status == 'success') && (!this.getLastPix && !this.getLastGenialPix))  {
        return 'Registrada'
      }
      return this.record.status
    },
    getLastPix() {
      if (!this.record.smartbank_pixs) { return null }
      if (this.record.smartbank_pixs.length == 0) { return null }
      return this.record.smartbank_pixs[this.record.smartbank_pixs.length - 1]
    },
    getLastGenialPix() {
      if (!this.record.genial_pixs) { return null }
      if (this.record.genial_pixs.length == 0) { return null }
      return this.record.genial_pixs[this.record.genial_pixs.length - 1]
    },
    genialPixStatus() {
      if (this.getLastGenialPix) {
        return this.getLastGenialPix.status
      } else {
        return 'none'
      }
    },
    genialPixStep() {
      if (this.getLastGenialPix) {
        return this.getLastGenialPix.step || ''
      } else {
        return ''
      }
    },
    companyDocument() {
      const document_type = this.receiver && this.receiver.document_type || false
      const document_number = this.receiver && this.receiver.document_number || false
      if (!document_type || !document_number) return ''
      return document_type.toUpperCase() + ' ' + utils.mask(document_type, document_number)
    },
    humanWireDate() {
      return utils.dbDateTimeToHuman(this.record.inserted_at).split(' ')[0]
    },
    humanWireTime() {
      return utils.dbDateTimeToHuman(this.record.inserted_at).split(' ')[1]
    }
  },
  methods: {
    updateBankAccount(e) {
      this.set_disable_buttons_handler()
      this.$emit('onUpdateBankAccount', this.record)
    },
    retryCompanyWire(e) {
      this.set_disable_buttons_handler()
      this.$emit('onRetryCompanyWire', this.record)
    },
    markAsSuccess(e) {
      this.set_disable_buttons_handler()
      this.$emit('onMarkAsSuccess', this.record)
    },
    set_disable_buttons_handler() {
      this.$root.$on('company-wire-actions-' + this.record.id, () => {
        this.company_wire_actions_disabled = true
      })
    },
    i18n(str) {
      return this.$root.l(str)
    },
    toogleView() {
      this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'

      const not_loaded = (this.transactionsLoaded === 'not_loaded')
      const error_loading = (this.transactionsLoaded === 'error_loading')
      const detailed_view = (this.current_view === 'detailed')

      if (detailed_view && (not_loaded || error_loading)) {
        if (this.admin) {
          this.loadBankTransactions()
        } else {
          this.loadScheduledBankTransactions()
        }
      }
    },
    loadBankTransactions() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.record.bank_transactions = response.body.data
          if (this.record.bank_transactions.length === 0) {
            this.transactionsLoaded = 'empty'
          } else {
            this.transactionsLoaded = 'ok'
          }
        } else {
          this.transactionsLoaded = 'error'
          console.log('successCallback', response)
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.transactionsLoaded = 'not_authorized'
        } else {
          this.transactionsLoaded = 'error'
        }
        console.log('errorCallback', response)
      }

      this.transactionsLoaded = 'not_loaded'
      let token = this.$cookies.get('api_token')
      const payload = { company_wire_ids: [this.record.id] }
      this.$http.post(this.$root.urls.admin__load_company_wire_bank_transactions, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    loadScheduledBankTransactions() {
      let successCallback = (response) => {
        if (response.body.data) {
          let mapper = function(scheduled_bank_transaction) {
            let transaction = { ...scheduled_bank_transaction }
            delete transaction.bank_transaction
            let bank_transaction = { ...scheduled_bank_transaction.bank_transaction }
            bank_transaction.scheduled_bank_transaction = transaction
            return bank_transaction
          }
          this.record.bank_transactions = response.body.data.map(mapper)
          if (this.record.bank_transactions.length === 0) {
            this.transactionsLoaded = 'empty'
          } else {
            this.transactionsLoaded = 'ok'
          }
        } else {
          this.transactionsLoaded = 'error'
          console.log('successCallback', response)
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.transactionsLoaded = 'not_authorized'
        } else {
          this.transactionsLoaded = 'error'
        }
        console.log('errorCallback', response)
      }

      this.transactionsLoaded = 'not_loaded'
      let token = this.$cookies.get('api_token')
      this.$http.get(`${this.$root.urls.customer__company_wires}/${this.record.id}/transactions`, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    openInNewWindow(url) {
      window.open(url, '_blank')
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    longAccountName(account) {
      if (account === null) { return '' }
      return utils.longAccountName(account)
    },
    exportTransactionCsvForCustomer() {
      utils.exportTransactionCsvForCustomer(this.exportTransactionCsv, this.record)
    },
    exportTransactionCsvForBank() {
      utils.exportTransactionCsvForBank(this.exportTransactionCsv)
    },
    exportTransactionCsv(header_line, pushLine, separator) {
      let exchanges_transactions = this.record.bank_transactions.reduce( ( rows_acc, bank_transaction ) => {
        pushLine(bank_transaction, rows_acc)
        return rows_acc
      }, [header_line])

      let filename = `wire-${this.record.id}.csv`
      utils.exportToCsv(filename, exchanges_transactions, separator)
    },
    openInfractionDialog() {
      this.infractionForm.company_wire_id = this.record.id
      this.infractionForm.type = 'reversal'
      this.infractionForm.description = ''
      this.infractionForm.method = null
      this.showInfractionDialog = true
      this.infractionViewError = ''
      this.$nextTick(() => {
        if (this.$refs.infractionFormRef) {
          this.$refs.infractionFormRef.resetValidation()
        }
      })
    },
    submitInfraction() {
      if (!this.infractionForm.description || !this.infractionForm.method) {
        this.infractionViewError = 'Preencha todos os campos obrigatórios.'
        return
      }
      const payload = {
        infraction: { ...this.infractionForm }
      }
      const token = this.$cookies.get('api_token')
      this.$http.post(this.$root.urls.admin__create_infraction, payload, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(() => {
        this.showInfractionDialog = false
        this.infractionViewError = ''
        this.infractionForm = {
          description: '',
          company_wire_id: '',
          type: '',
          method: null
        }
        this.$root.$emit('alert', 'Infração criada com sucesso!')
      }).catch(err => {
        try {
          const body = JSON.parse(err.bodyText)
          const translated = this.i18n(body.error)
          this.infractionViewError = translated || 'Erro ao criar infração.'
        } catch (e) {
          this.infractionViewError = 'Erro desconhecido ao criar infração.'
        }
      })
    },
    openChargebackDialog(record) {
      this.chargebackForm = {
        description: '',
        amount: '',
        reason: 'flaw',
      }
      this.chargebackFormError = ''
      this.chargeBackRecord = record
      this.chargebackDialog = true
      this.$nextTick(() => {
        if (this.$refs.chargebackFormRef) {
          this.$refs.chargebackFormRef.resetValidation()
        }
      })
    },
    openInfractionDialog() {
      this.infractionForm.company_wire_id = this.record.id
      this.infractionForm.type = 'reversal'
      this.infractionForm.description = ''
      this.infractionForm.method = null
      this.showInfractionDialog = true
      this.infractionViewError = ''
      this.$nextTick(() => {
        if (this.$refs.infractionFormRef) {
          this.$refs.infractionFormRef.resetValidation()
        }
      })
    },
    submitInfraction() {
      if (!this.infractionForm.description || !this.infractionForm.method) {
        this.infractionViewError = 'Preencha todos os campos obrigatórios.'
        return
      }
      const payload = {
        infraction: { ...this.infractionForm }
      }
      const token = this.$cookies.get('api_token')
      this.$http.post(this.$root.urls.admin__create_infraction, payload, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(() => {
        this.showInfractionDialog = false
        this.infractionViewError = ''
        this.infractionForm = {
          description: '',
          company_wire_id: '',
          type: '',
          method: null
        }
        this.$root.$emit('alert', 'Infração criada com sucesso!')
      }).catch(err => {
        try {
          const body = JSON.parse(err.bodyText)
          const translated = this.i18n(body.error)
          this.infractionViewError = translated || 'Erro ao criar infração.'
        } catch (e) {
          this.infractionViewError = 'Erro desconhecido ao criar infração.'
        }
      })
    },
    openChargebackDialog(record) {
      this.chargebackForm = {
        description: '',
        amount: '',
        reason: 'flaw',
      }
      this.chargebackFormError = ''
      this.chargeBackRecord = record
      this.chargebackDialog = true
      this.$nextTick(() => {
        if (this.$refs.chargebackFormRef) {
          this.$refs.chargebackFormRef.resetValidation()
        }
      })
    },
    submitChargeback() {
      if (!this.chargebackForm.description || !this.chargebackForm.amount) {
        this.chargebackFormError = 'Preencha todos os campos obrigatórios.'
        return
      }
      const payload = {
        description: this.chargebackForm.description,
        amount: String(this.chargebackForm.amount),
        reason: this.chargebackForm.reason,
        company_wire_id: this.chargeBackRecord.id
      }
      this.chargebackFormError = ''
      const token = this.$cookies.get('api_token')
      this.$http.post(this.$root.urls.admin__create_chargeback, payload, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(() => {
        this.chargebackDialog = false
        this.$root.$emit('showSnackbar', { message: 'Chargeback solicitado com sucesso.', color: 'success' })
      }).catch(error => {
        const messages = this.extractErrors(error)
        this.chargebackFormError = messages.join(', ')
      })
    },
    extractErrors(response) {
      try {
        const data = JSON.parse(response.bodyText || '{}')
        const messages = []
        if (data.errors) {
          for (const field in data.errors) {
            const fieldMessages = data.errors[field]
            fieldMessages.forEach(msg => {
              const translatedMsg = this.i18n(msg)
              messages.push(`${translatedMsg}`)
            })
          }
        } else {
          messages.push(this.i18n(data.error))
        }

        return messages
      } catch (e) {
        return [this.i18n('Erro inesperado ao processar a resposta.')]
      }
    }
  },
  mounted() {
  }
}
</script>

<style>
  .error-description{
    font-size: 14px;
    background-color: #fae4e4;
    padding: 10px;
  }
  .error-description div{
    margin-bottom: 8px;
  }
  .error-description span{
    font-size: medium;
  }
  .top.icons_wrapper {
    position: absolute;
    right: 0px;
    top: -20px;
    display: flex;
    justify-content: center
  }
  .bottom.icons_wrapper {
    position: absolute;
    right: 0px;
    bottom: -18px;
    display: flex;
    justify-content: center
  }
  .icons_wrapper .icon {
    width: 20px;
    height: 20px;
  }
  .wire_status {
    margin: 1px 0px 0px 2px;
  }
  .icons_wrapper .success {
    color: #27dabc;
    background-color: transparent!important;
  }
  .icons_wrapper .fail {
    color: red;
  }
  .icons_wrapper .waiting {
    color: #2c4cc1;
  }
  .icons_wrapper .processing {
    color: #2c4cc1;
  }
  .cursor-default {
    cursor: default!important;
  }
  .rounded-chip {
    background-image: linear-gradient(0deg, var(--secondary-button-background-color), var(--secondary-button-background-color), rgba(135,199,201,1));
    border-radius: 10px;
    padding: 3px 10px 3px 10px;
    color: white;
  }
  .rounded-chip.small {
    padding: 0px 6px 0px 6px;
    margin: 0px 0px 0px 8px;
  }
</style>



// WEBPACK FOOTER //
// src/WireItem.vue